import React, { FC } from "react";

import { TModalComponentsListProps } from "../../types/ContentHubSeriesDetails.type";
import InnerCard from "./InnerCard";
import "./styles.scss";

const InnerCards: FC<TModalComponentsListProps> = (props) => {
  const model = props.components;

  return (
    <div className="inner-cards-modules">
      {model.map((component, index) => (
        <InnerCard
          component={component}
          key={`inner-card-module-item-${index}`}
        />
      ))}
    </div>
  );
};

export default InnerCards;
